import { MediaObject } from 'types'
import validators from './base'
import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'
import twitter from 'twitter-text'

// Source: https://developer.x.com/en/docs/x-api/v1/media/upload-media/uploading-media/media-best-practices

const xContentValidator = (content: string): string[] => {
  const rules = {
    maxCharacters: 280,
  }
  const weightedLength = twitter.parseTweet(content).weightedLength
  if (weightedLength > rules.maxCharacters) {
    return [`Content exceeds ${rules.maxCharacters} characters (${weightedLength})`]
  }

  return []
}

const xFileValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxImages: 4,
    minImages: 0,
  }

  return validators.validateFileCount(files, rules.minImages, rules.maxImages)
}

const xVideoSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 512 * 1024 * 1024, // 512MB
  }

  return validators.validateVideosSize(files, rules.maxSize, 'MB')
}

const xImageSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 5 * 1024 * 1024, // 5MB
  }

  return validators.validateImagesSize(files, rules.maxSize, 'MB')
}

const xDurationValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minDuration: 1,
    maxDuration: 140,
  }

  return validators.validateVideosDuration(files, rules.minDuration, rules.maxDuration, 'seconds')
}

const xAspectRatioValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minAspectRatio: 0.33,
    maxAspectRatio: 3,
  }

  const labels = {
    minAspectRatio: '1:3',
    maxAspectRatio: '3:1',
  }

  return validators.validateVideosAspectRatio(
    files,
    rules.minAspectRatio,
    rules.maxAspectRatio,
    labels.minAspectRatio,
    labels.maxAspectRatio,
  )
}

const xFormatValidator = (files: MediaObject[]): string[] => {
  const formats = ['video/mp4']

  return validators.validateVideosFormat(files, formats, 'X')
}

const xVideosCountValidator = (_files: MediaObject[]): string[] => {
  return []
}

const xPostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const xValidators = {
  validateContent: xContentValidator,
  validateFiles: xFileValidator,
  validateVideosSize: xVideoSizeValidator,
  validateImagesSize: xImageSizeValidator,
  validateVideosDuration: xDurationValidator,
  validateVideosAspectRatio: xAspectRatioValidator,
  validateVideosFormat: xFormatValidator,
  validateVideosCount: xVideosCountValidator,
  validatePostSettings: xPostSettingsValidator,
}

export default xValidators
